import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import {
    SettingType,
    Widget,
} from '@appblocks/codegeneration/types';
import BaseWidget, { sizes } from '@appblocks/codegeneration/Widgets/BaseWidget';

export default class GaugeWidget extends BaseWidget {
    constructor() {
        super();
        this.name = 'Gauge Widget';
        this.id = 'gauge_widget';
        this.minW = sizes[this.id].minW;
        this.minH = sizes[this.id].minH;

        const settings = this.getWidgetSettings(['VARIABLE', 'LABEL', 'MIN', 'MAX', 'DECIMAL_PLACES']);

        this.settings = this.settings.concat(settings);
    }
}
